// extracted by mini-css-extract-plugin
export default {"column":"mNB2W","appear-from-above":"Px1nR","appearFromAbove":"Px1nR"};